"use client";
// import { months, tourPackagesData } from "@/data/tourPackagesData";
// import { months } from "@/data/tourPackagesData";
import { Clock, MapPin } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import { IPackageRecord } from "../interface/IPackageData.interface";
import { months } from "@/data/tourPackagesData";
import { useSession } from "next-auth/react";
import { useModal } from "@/core/context/ModalContext";
import { showErrorMessage } from "@/utils/toastMessage/toast.message";

interface IProps {
  activeTab: string;
  content: IPackageRecord[];
}

const GridView: React.FC<IProps> = ({ content }) => {
  const { status } = useSession();
  const isLoggedIn = status === "authenticated";

  const { openModal } = useModal();

  const handleNotLoggedIn = () => {
    openModal("login");
    showErrorMessage("Please login to access this feature.");
  };

  return (
    <div className="flex-1 flex flex-col overflow-hidden py-5 space-y-5">
      {/* <p className="typo-manrope-large-body-text-semi-bold text-text-500">
        {activeTab}
      </p> */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-10 overflow-y-auto">
        {content.map((packageItem: IPackageRecord) => (
          <div key={packageItem.id} className=" overflow-hidden">
            <Image
              src={packageItem?.image || "/placeholder.png"}
              alt={packageItem?.name || "package-image"}
              width={500}
              height={300}
              className="h-52 w-full object-cover rounded-3xl overflow-hidden"
            />
            <div className="p-4 flex flex-col gap-2">
              <div className="">
                <p className="typography-small-body text-blue-600 inline-flex gap-1 mb-2 items-center justify-center">
                  <MapPin size={12} /> {packageItem?.destination}
                </p>
                <Link href={`/package/${packageItem?.slug}`}>
                  <h2
                    className="typography-sub-h2-regular text-grey-700 font-medium my-3 line-clamp-1"
                    title={packageItem?.name || ""}
                  >
                    {packageItem?.name}
                  </h2>
                </Link>
                <p
                  className="typography-small-body-light text-grey-500 line-clamp-2"
                  dangerouslySetInnerHTML={{
                    __html: packageItem?.description || "",
                  }}
                />
                <div className="flex flex-row justify-between mt-3 gap-3">
                  <p className="typography-large-body font-medium text-grey-700">
                    Starting Price:{" "}
                    <span className="typography-large-body font-medium text-grey-700">
                      NRS {packageItem?.current_price}
                    </span>
                  </p>
                  <p className="text-grey-500 inline-flex gap-1 items-center justify-center mb-2">
                    <Clock size={17} /> {packageItem?.duration} days
                  </p>
                </div>

                <div className="flex flex-row mt-3 gap-3">
                  <div className="flex-1">
                    {isLoggedIn ? (
                      <Link href={`/user/book/${packageItem.id}`}>
                        <button className="w-full typography-large-body text-white bg-primary-500 py-3 rounded-[10px] hover:bg-primary-600">
                          Book Now
                        </button>
                      </Link>
                    ) : (
                      <div
                        onClick={handleNotLoggedIn}
                        className="w-full typography-large-body text-white bg-primary-500 py-3 rounded-[10px] hover:bg-primary-600 text-center cursor-pointer"
                      >
                        Book Now
                      </div>
                    )}
                  </div>
                  <div className="flex-1">
                    <Link href={`/package/${packageItem?.slug}`}>
                      <button className="w-full typography-large-body font-light text-yellow-500 py-3 rounded-[10px] border border-yellow-500">
                        Learn More
                      </button>
                    </Link>
                  </div>
                </div>
                {/* <div className="flex flex-row mt-2"> */}
                <p className="typography-mid-body text-grey-500 my-2 flex flex-row">
                  <span className="ml-2 mt-2 inline-flex flex-wrap gap-3">
                    Availability:
                    {months.map((month) => {
                      const available = packageItem?.availability_month?.some(
                        (m: string) => {
                          const a = m.toLowerCase().trim();
                          return (
                            a === month.toLowerCase() ||
                            a.startsWith(month.slice(0, 3).toLowerCase())
                          );
                        }
                      );
                      return (
                        <span
                          key={month}
                          className={`${
                            available
                              ? "font-medium  text-green-500"
                              : "font-light line-through"
                          }`}
                        >
                          {month.slice(0, 3)}
                        </span>
                      );
                    })}
                  </span>
                </p>
              </div>
            </div>
          </div>
          // </div>
        ))}
      </div>
    </div>
  );
};

export default GridView;
